import React from 'react';
import useTheme from '../../hooks/useTheme';

const LegalHeader = () => {
  const { effectiveTheme } = useTheme();

  return (
    <div className="border-b border-gray-800 px-4 py-2 mb-6 flex justify-center">
      <a
        href="/"
        onClick={e => {
          e.preventDefault();
          window.history.pushState({}, '', '/');
          window.dispatchEvent(new PopStateEvent('popstate'));
        }}
        className="inline-flex items-center space-x-2"
      >
        <img src="/logos/logo-transparent-smll.png" alt="" className="h-5 w-auto object-contain" />
        <img
          src={effectiveTheme === 'dark' ? '/logos/logo-loft-dark-theme-582x243.png' : '/logos/logo-loft-light-theme-582x243.png'}
          alt="Loft"
          className="h-5 w-auto object-contain"
        />
      </a>
    </div>
  );
};

export default LegalHeader;
